module.exports = __webpack_public_path__ + "static/media/400153_02.30870641.png";